'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'cherries';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = 'M270.6 0L178.8 214.1C160.2 200.2 137 192 112 192 50.1 192 0 242.1 0 304 0 401.2 86 480 192 480s192-78.8 192-176c0-61.9-50.1-112-112-112-20 0-38.8 5.3-55.1 14.5L290.7 34.3 400.3 208.4c7 9.3 12.9 19.4 17.7 30.1 13-9.2 28.9-14.5 46-14.5 44.2 0 80 35.8 80 80 0 77-69 144-160 144-2.6 0-5.3-.1-7.9-.2-9.4 10.4-19.7 20-30.9 28.6 12.5 2.4 25.5 3.6 38.8 3.6 106 0 192-78.8 192-176 0-61.9-50.1-112-112-112-11.5 0-22.6 1.7-33.1 5L306.9 0 270.6 0zM169.1 248L192 271.3 214.9 248c14.6-14.9 34.8-24 57.1-24 44.2 0 80 35.8 80 80 0 77-69 144-160 144S32 381 32 304c0-44.2 35.8-80 80-80 22.4 0 42.6 9.2 57.1 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;